import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { PERMISSION } from 'src/features/auth/types';
import { gatewayMessages } from 'src/features/gatewayPass/utils/messages';
import { PATH } from 'src/features/navigation/utils/constants';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';
import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { useTitleStore } from 'src/stores/useTitleStore';

const VisitorsLayout = () => {
    const { formatMessage } = useIntl();

    const accessActiveStays = useHasPermissions([PERMISSION.ACCESS_ACTIVE_STAYS]);
    const accessPastStays = useHasPermissions([PERMISSION.ACCESS_PAST_STAYS]);
    const accessVisitors = useHasPermissions([PERMISSION.ACCESS_VISITORS]);
    const accessEventLog = useHasPermissions([PERMISSION.ACCESS_EVENT_LOGS]);
    const accessGatewayPasses = useHasPermissions([PERMISSION.ACCESS_GATEWAY_PASSES]);

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(visitorMessages.visitors));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <TabRow>
                {accessActiveStays && (
                    <Tab end to={`/${PATH.VISITORS}/active-stays`}>
                        <FormattedMessage {...visitorMessages.activeStays} />
                    </Tab>
                )}
                {accessPastStays && (
                    <Tab end to={`/${PATH.VISITORS}/past-stays`}>
                        <FormattedMessage {...visitorMessages.pastStays} />
                    </Tab>
                )}
                {accessVisitors && (
                    <Tab end to={`/${PATH.VISITORS}/visitors`}>
                        <FormattedMessage {...visitorMessages.visitors} />
                    </Tab>
                )}
                {accessGatewayPasses && (
                    <Tab end to={`/${PATH.VISITORS}/gateway-passes`}>
                        <FormattedMessage {...visitorMessages.gatewayPasses} />
                    </Tab>
                )}
                {accessEventLog && (
                    <Tab end to={`/${PATH.VISITORS}/event-log`}>
                        <FormattedMessage {...gatewayMessages.eventLog} />
                    </Tab>
                )}
            </TabRow>
            <Outlet />
        </MainLayout>
    );
};

export default VisitorsLayout;
